import { Injectable } from '@jkhy/frontend-utils/di';
import { ObservationSource } from '@jkhy/frontend-utils/observable';
import { nothing } from 'lit';
import { TmFooterConfig, defaultConfig } from './footer.service.types';

@Injectable()
export class TmFooterService {
    private config: TmFooterConfig = defaultConfig;

    private configSource = new ObservationSource<TmFooterConfig>();

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly config$ = this.configSource.toObservable();

    public configure(c: Partial<TmFooterConfig>, retain: boolean = false) {
        this.config = normalizeConfig(this.config, c, retain);
        this.configSource.emit(this.config);
    }

    public hide() {
        this.configure({ visible: false }, true);
    }

    public renderSlotContent() {
        const { slotContent } = this.config;
        if (!slotContent) {
            return nothing;
        }
        return typeof slotContent === 'function' ? slotContent() : slotContent;
    }
}

function normalizeConfig(
    currentConfig: TmFooterConfig,
    incomingConfig: Partial<TmFooterConfig>,
    retain: boolean
): TmFooterConfig {
    const retainedConfig = retain ? currentConfig : {};
    return {
        ...defaultConfig,
        ...retainedConfig,
        ...incomingConfig,
    };
}
